module.exports = __webpack_public_path__ + "static/img/arinkel-3.af8ffdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/arinkel-3.jpg
// module id = txGr
// module chunks = 1